require('./runtime');
(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("./baseinput"), require("./utils"));
	else if(typeof define === 'function' && define.amd)
		define(["./baseinput", "./utils"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("./baseinput"), require("./utils")) : factory(root["./baseinput"], root["./utils"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(globalThis, (__WEBPACK_EXTERNAL_MODULE__83828__, __WEBPACK_EXTERNAL_MODULE__78815__) => {
return (globalThis["wpBaUiCarbonToolkit"] = globalThis["wpBaUiCarbonToolkit"] || []).push([[307],{

/***/ 27213:
/***/ ((module) => {

var amdi18n={"__root":{"empty":"Enter a number.","max":"Enter a number less than or equal to %{value}.","maxLT":"Enter a number less than %{value}.","min":"Enter a number greater than or equal to %{value}.","minGT":"Enter a number greater than %{value}.","scale":"Enter a number with a scale of less than or equal to %{value}.","scale0":"Enter an integer number."},"__cs":{"empty":"Zadejte platné číslo.","max":"Zadejte číslo, které bude menší nebo rovno %{value}.","maxLT":"Zadejte číslo, které bude menší než %{value}.","min":"Zadejte číslo, které bude větší nebo rovno %{value}.","minGT":"Zadejte číslo, které bude větší než %{value}.","scale":"Zadejte číslo s počtem číslic, který bude menší nebo roven %{value}.","scale0":"Zadejte celé číslo."},"__da":{"empty":"Angiv et gyldigt nummer.","max":"Angiv et tal, der er mindre end eller lig med %{value}.","maxLT":"Angiv et tal, der er mindre end %{value}.","min":"Angiv et tal, der er større end eller lig med %{value}.","minGT":"Angiv et tal, der er større end %{value}.","scale":"Angiv et tal i en skala med mindre end eller lig med %{value}.","scale0":"Angiv et heltal."},"__de":{"empty":"Geben Sie eine gültige Zahl ein. ","max":"Geben Sie eine Zahl kleiner-gleich %{value} ein. ","maxLT":"Geben Sie eine Zahl kleiner als %{value} ein. ","min":"Geben Sie eine Zahl größer-gleich %{value} ein. ","minGT":"Geben Sie eine Zahl größer als %{value} ein. ","scale":"Geben Sie eine Zahl mit einer Anzahl von Kommastellen kleiner-gleich %{value} ein.","scale0":"Geben Sie eine ganze Zahl ein. "},"__es":{"empty":"Escriba un número válido. ","max":"Escriba un número menor que o igual a %{value}.","maxLT":"Escriba un número menor que %{value}.","min":"Escriba un número mayor que o igual a %{value}.","minGT":"Escriba un número mayor que %{value}.","scale":"Escriba un número con una escala menor que o igual a %{value}.","scale0":"Escriba un número entero."},"__fi":{"empty":"Anna kelvollinen luku.","max":"Anna luku, joka on pienempi tai yhtä suuri kuin %{value}.","maxLT":"Anna luku, joka on pienempi kuin %{value}.","min":"Anna luku, joka on suurempi tai yhtä suuri kuin %{value}.","minGT":"Anna luku, joka on suurempi kuin %{value}.","scale":"Anna luku, jonka asteikko on pienempi tai yhtä suuri kuin %{value}.","scale0":"Anna kokonaisluku."},"__fr":{"empty":"Entrez un nombre valide.","max":"Entrez un nombre inférieur ou égal à %{value}.","maxLT":"Entrez un nombre inférieur à %{value}.","min":"Entrez un nombre supérieur ou égal à %{value}.","minGT":"Entrez un nombre supérieur à %{value}.","scale":"Entrez un nombre avec une échelle inférieure ou égale à %{value}.","scale0":"Entrez un nombre entier."},"__hr":{"empty":"Molim, unesite važeći broj.","max":"Unesite broj manji ili jednak %{value}.","maxLT":"Unesite broj manji od %{value}.","min":"Unesite broj veći ili jednak %{value}.","minGT":"Unesite broj veći od %{value}.","scale":"Unesite broj na skali manji ili jednak  %{value}.","scale0":"Unesite cijeli broj."},"__hu":{"empty":"Adjon meg egy érvényes számot.","max":"Adjon meg egy legfeljebb %{value} értékű számot.","maxLT":"Adjon meg egy %{value} értéknél kisebb számot.","min":"Adjon meg egy legalább %{value} értékű számot.","minGT":"Adjon meg egy %{value} értéknél nagyobb számot.","scale":"Adjon meg egy számot legfeljebb %{value} skálán. ","scale0":"Adjon meg egy egész számot. "},"__it":{"empty":"Immettere un numero valido.","max":"Immettere un numero minore o uguale a %{value}.","maxLT":"Immettere un numero minore di %{value}.","min":"Immettere un numero maggiore o uguale a %{value}.","minGT":"Immettere un numero maggiore di %{value}.","scale":"Immettere un numero con una scala minore o uguale a %{value}.","scale0":"Immettere un numero intero."},"__ja":{"empty":"有効な数を入力してください。","max":"%{value} 以下の値を入力してください。","maxLT":"%{value} 未満の値を入力してください。","min":"%{value} 以上の値を入力してください。","minGT":"%{value} より大きい値を入力してください。","scale":"小数部桁数が %{value} 以内の数を入力してください。","scale0":"整数を入力してください。"},"__kk":{"empty":"Жарамды санды енгізіңіз.","max":"%{value}-дан кем немесе оған тең санды енгізіңіз.","maxLT":"%{value}-дан кем санды енгізіңіз.","min":"%{value}-дан үлкен немесе оған тең санды енгізіңіз.","minGT":"%{value}-дан үлкен санды енгізіңіз.","scale":"%{value}-дан кем немесе оған тең сандық разрядымен санды енгізіңіз.","scale0":"Бүтін санды енгізіңіз."},"__ko":{"empty":"올바른 숫자를 입력하십시오.","max":"%{value}보다 작거나 같은 숫자를 입력하십시오.","maxLT":"%{value}보다 작은 숫자를 입력하십시오.","min":"%{value}보다 크거나 같은 숫자를 입력하십시오.","minGT":"%{value}보다 큰 숫자를 입력하십시오.","scale":"%{value}보다 작거나 같은 스케일의 숫자를 입력하십시오.","scale0":"정수를 입력하십시오."},"__nb":{"empty":"Oppgi et gyldig tall.","max":"Oppgi et tall som er mindre enn eller lik %{value}.","maxLT":"Oppgi et tall som er mindre enn %{value}.","min":"Oppgi et tall som er større enn eller lik %{value}.","minGT":"Oppgi et tall som er større enn %{value}.","scale":"Oppgi et tall med en skala som er mindre enn eller lik %{value}.","scale0":"Oppgi et heltall."},"__nl":{"empty":"Geef een geldig getal op.","max":"Geef een getal op dat kleiner is dan of gelijk is aan %{value}.","maxLT":"Geef een getal op dat kleiner is dan %{value}.","min":"Geef een getal op dat groter is dan of gelijk is aan %{value}.","minGT":"Geef een getal op dat groter is dan %{value}.","scale":"Geef een getal op met een schaal die kleiner is dan of gelijk is aan %{value}.","scale0":"Geef een geheel getal op."},"__no":{"empty":"Oppgi et gyldig tall.","max":"Oppgi et tall som er mindre enn eller lik %{value}.","maxLT":"Oppgi et tall som er mindre enn %{value}.","min":"Oppgi et tall som er større enn eller lik %{value}.","minGT":"Oppgi et tall som er større enn %{value}.","scale":"Oppgi et tall med en skala som er mindre enn eller lik %{value}.","scale0":"Oppgi et heltall."},"__pl":{"empty":"Wprowadź poprawną liczbę.","max":"Wprowadź liczbę mniejszą lub równą %{value}.","maxLT":"Wprowadź liczbę mniejszą niż %{value}.","min":"Wprowadź liczbę większą lub równą %{value}.","minGT":"Wprowadź liczbę większą niż %{value}.","scale":"Wprowadź liczbę o skali nie większej niż %{value}.","scale0":"Wprowadź liczbę całkowitą."},"__pt":{"empty":"Insira um número válido.","max":"Insira um número menor ou igual a %{value}.","maxLT":"Insira um número menor que %{value}.","min":"Digite um número maior ou igual a %{value}.","minGT":"Insira um número maior que %{value}.","scale":"Insira um número com uma escala menor ou igual a %{value}.","scale0":"Insira um número inteiro."},"__pt-br":{"empty":"Insira um número válido.","max":"Insira um número menor ou igual a %{value}.","maxLT":"Insira um número menor que %{value}.","min":"Digite um número maior ou igual a %{value}.","minGT":"Insira um número maior que %{value}.","scale":"Insira um número com uma escala menor ou igual a %{value}.","scale0":"Insira um número inteiro."},"__ro":{"empty":"Vă rugăm introduceţi un număr valid. ","max":"Introduceţi un număr mai mic sau egal cu %{value}.","maxLT":"Introduceţi un număr mai mic decât %{value}.","min":"Introduceţi un număr mai mare sau egal cu %{value}.","minGT":"Introduceţi un număr mai mare decât %{value}.","scale":"Introduceţi un număr cu o scală mai mică sau egală cu %{value}.","scale0":"Introduceţi un număr întreg."},"__ru":{"empty":"Введите допустимое число.","max":"Введите число меньше или равное %{value}.","maxLT":"Введите число меньше %{value}.","min":"Введите число больше или равное %{value}.","minGT":"Введите число больше %{value}.","scale":"Введите число с числом разрядов меньше или равным %{value}.","scale0":"Введите целое число."},"__sl":{"empty":"Vnesite veljavno število.","max":"Vnesite število, manjše od ali enako %{value}.","maxLT":"Vnesite število, manjše od %{value}.","min":"Vnesite število, večje od ali enako %{value}.","minGT":"Vnesite število, večje od %{value}.","scale":"Vnesite število z merilom, ki je manjše od ali enako %{value}.","scale0":"Vnesite celo število."},"__sv":{"empty":"Ange ett giltigt tal.","max":"Ange ett tal som är mindre än eller lika med %{value}.","maxLT":"Ange ett tal som är mindre än %{value}.","min":"Ange ett tal som är större än eller lika med %{value}.","minGT":"Ange ett tal som är större än %{value}.","scale":"Ange ett tal i en skala mindre än eller lika med %{value}.","scale0":"Ange ett heltal."},"__th":{"empty":"โปรดป้อนตัวเลขที่ถูกต้อง","max":"ป้อนตัวเลขที่น้อยกว่าหรือเท่ากับ %{value}","maxLT":"ป้อนตัวเลขที่น้อยกว่า %{value}","min":"ป้อนตัวเลขที่มากกว่าหรือเท่ากับ %{value}","minGT":"ป้อนตัวเลขที่มากกว่า %{value}","scale":"ป้อนตัวเลขที่มีสเกลน้อยกว่าหรือเท่ากับ %{value}","scale0":"ป้อนเลขจำนวนเต็ม"},"__tr":{"empty":"Lütfen geçerli bir sayı girin.","max":"Bundan küçük ya da buna eşit bir sayı girin: %{value}.","maxLT":"Bundan küçük bir sayı girin: %{value}.","min":"Bundan büyük ya da buna eşit bir sayı girin: %{value}.","minGT":"Bundan büyük bir sayı girin: %{value}.","scale":"Bu ölçekten küçük ya da buna eşit bir sayı girin: %{value}.","scale0":"Tam sayı girin. "},"__zh":{"empty":"请输入有效数字。","max":"请输入小于或等于 %{value} 的数字。","maxLT":"请输入小于 %{value} 的数字。","min":"请输入大于或等于 %{value} 的数字。","minGT":"请输入大于 %{value} 的数字。","scale":"请输入小数位数小于或等于 %{value} 的数字。","scale0":"请输入整数。"},"__zh-cn":{"empty":"请输入有效数字。","max":"请输入小于或等于 %{value} 的数字。","maxLT":"请输入小于 %{value} 的数字。","min":"请输入大于或等于 %{value} 的数字。","minGT":"请输入大于 %{value} 的数字。","scale":"请输入小数位数小于或等于 %{value} 的数字。","scale0":"请输入整数。"},"__zh-hk":{"empty":"請輸入有效數字。","max":"輸入小於或等於 %{value} 的數字。","maxLT":"輸入小於 %{value} 的數字。","min":"輸入大於或等於 %{value} 的數字。","minGT":"輸入大於 %{value} 的數字。","scale":"輸入小於或等於 %{value} 的小數位數。","scale0":"輸入整數。"},"__zh-mo":{"empty":"請輸入有效數字。","max":"輸入小於或等於 %{value} 的數字。","maxLT":"輸入小於 %{value} 的數字。","min":"輸入大於或等於 %{value} 的數字。","minGT":"輸入大於 %{value} 的數字。","scale":"輸入小於或等於 %{value} 的小數位數。","scale0":"輸入整數。"},"__zh-sg":{"empty":"请输入有效数字。","max":"请输入小于或等于 %{value} 的数字。","maxLT":"请输入小于 %{value} 的数字。","min":"请输入大于或等于 %{value} 的数字。","minGT":"请输入大于 %{value} 的数字。","scale":"请输入小数位数小于或等于 %{value} 的数字。","scale0":"请输入整数。"},"__zh-tw":{"empty":"請輸入有效數字。","max":"輸入小於或等於 %{value} 的數字。","maxLT":"輸入小於 %{value} 的數字。","min":"輸入大於或等於 %{value} 的數字。","minGT":"輸入大於 %{value} 的數字。","scale":"輸入小於或等於 %{value} 的小數位數。","scale0":"輸入整數。"}};amdi18n.init=function(language){
		// get the default language
		if(!language){
			if(window._i18n && window._i18n.locale){
				language = window._i18n.locale;
			}else if(document.documentElement.lang){
				language = document.documentElement.lang;
			}else{
				language = 'root';
			}
		}
		var target = this['__' + language] || this.__root;

		// copy definition to root level
		if (target) {
			for (var name in target) {
				this[name] = target[name];
			}
		}

		// fallback to root
		for(var name in this.__root){
			if(typeof this[name] === 'undefined'){
				this[name] = this.__root[name];
			}
		}
	};amdi18n.init();module.exports=amdi18n;

/***/ }),

/***/ 27611:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


var _interopRequireDefault = __webpack_require__(97880);
exports.__esModule = true;
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(__webpack_require__(38213));
var _defineProperty2 = _interopRequireDefault(__webpack_require__(68779));
var _react = _interopRequireWildcard(__webpack_require__(16689));
var _baUiCarbon = __webpack_require__(6536);
var _propTypes = _interopRequireDefault(__webpack_require__(580));
var _utils = __webpack_require__(78815);
var _baseinput = _interopRequireDefault(__webpack_require__(83828));
var _StringResource = _interopRequireDefault(__webpack_require__(92460));
var _NumberInput = _interopRequireDefault(__webpack_require__(58610));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019, 2020
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */

const {
  sanitize,
  getInheritedProps
} = _utils.propsUtils;
const STYLE_CLASS = _NumberInput.default.numberInputClassName.replace(/"/g, '');
const DEFAULT_VALIDATION = new RegExp(/^[+-]{0,1}[0-9]*([.][0-9]*){0,1}$/);

// accept only a valid string as input
const fixupValue = (value, useOnValueCallbacks) => {
  if (value === undefined) {
    return undefined;
  }
  if (typeof value === 'number') {
    return String(value);
  }
  if (typeof value === 'string' && value.length) {
    // old validation callbacks allowed invalid values, new validations do not
    if (!useOnValueCallbacks) {
      return value;
    }
    return String(Number(value));
  }
  return '';
};

// check value; and return a bound value and message when applicable
const checkValue = (value, _ref) => {
  let {
    min,
    gtMin,
    max,
    ltMax,
    step,
    scale,
    allowEmpty
  } = _ref;
  if ((value != null ? value : '') === '') {
    if (allowEmpty) {
      return {
        value: '',
        message: undefined,
        bound: false
      };
    }
    return {
      value: undefined,
      message: _StringResource.default.get('empty'),
      bound: false
    };
  }
  if (!DEFAULT_VALIDATION.test(value)) {
    // not a possible number
    return {
      value: undefined,
      message: _StringResource.default.get('empty'),
      bound: false
    };
  }
  if (isNaN(value)) {
    // not yet a nubmer
    return {
      value: undefined,
      message: _StringResource.default.get('empty'),
      bound: false
    };
  }
  const number = Number(value);
  if (min !== undefined) {
    if (gtMin !== undefined) {
      // number must be > min
      if (!(number > Number(min))) {
        return {
          value: min + step,
          message: _StringResource.default.get('minGT', {
            value: min
          }),
          bound: true
        };
      }
      // number must be >= min
    } else if (!(number >= Number(min))) {
      return {
        value: min,
        message: _StringResource.default.get('min', {
          value: min
        }),
        bound: true
      };
    }
  }
  if (max !== undefined) {
    if (ltMax !== undefined) {
      // number must be < max
      if (!(number < Number(max))) {
        return {
          value: max - step,
          message: _StringResource.default.get('maxLT', {
            value: max
          }),
          bound: true
        };
      }
      // number must be <= max
    } else if (!(number <= Number(max))) {
      return {
        value: max,
        message: _StringResource.default.get('max', {
          value: max
        }),
        bound: true
      };
    }
  }
  if (scale !== undefined) {
    const stringParts = String(number).split('.');
    if (stringParts[1]) {
      const numScale = Number(scale);
      if (numScale === 0) {
        return {
          value: stringParts[0],
          message: _StringResource.default.get('scale0'),
          bound: true
        };
      } else if (stringParts[1].length > scale) {
        return {
          value: `${stringParts[0]}.${stringParts[1].slice(0, numScale)}`,
          message: _StringResource.default.get('scale', {
            value: scale
          }),
          bound: true
        };
      }
    }
  }
  return {
    value,
    message: undefined,
    bound: false
  };
};
class NumberInput extends _react.Component {
  constructor(_props) {
    super(_props);
    (0, _defineProperty2.default)(this, "_useOnValueCallbacks", !!this.props.onValueChange || !!this.props.onValueAccept);
    (0, _defineProperty2.default)(this, "_ref", input => {
      this._input = input;
    });
    (0, _defineProperty2.default)(this, "_onChangeWithUpdate", v => {
      const {
        onChange,
        validation
      } = this.props;
      let value = v;
      if (validation) {
        if (!validation(value)) {
          return; // ignore input if invalid
        }
        // check if custom validated value can be constrained
        value = isNaN(value) ? value : this._constrainedValue(value);
      } else {
        value = this._constrainedValue(value) || this.props.value;
      }
      onChange == null ? void 0 : onChange(value);
    });
    (0, _defineProperty2.default)(this, "_onBlur", e => {
      const {
        value,
        onBlur
      } = this.props;
      this.setState({
        displayValue: value
      });
      this._onChangeWithUpdate(e.currentTarget.value);
      onBlur == null ? void 0 : onBlur(e);
    });
    (0, _defineProperty2.default)(this, "_onChange", (newValue, finalFireOnBlur) => {
      const {
        onChange,
        validation,
        fireOnBlur,
        value
      } = this.props;
      this.setState({
        displayValue: finalFireOnBlur ? value : newValue
      });

      // Use custom validation function if provided by consumer
      if (validation && newValue !== '') {
        if (!validation(newValue)) {
          return; // ignore input if invalid
        }

        (!fireOnBlur || finalFireOnBlur && Number(newValue) !== Number(value)) && (onChange == null ? void 0 : onChange(newValue));
      } else if (DEFAULT_VALIDATION.test(newValue)) {
        (!fireOnBlur || finalFireOnBlur && Number(newValue) !== Number(value)) && (onChange == null ? void 0 : onChange(newValue));
      }
    });
    (0, _defineProperty2.default)(this, "_onValueChange", newValue => {
      const {
        onValueChange
      } = this.props;
      const {
        value,
        message,
        bound
      } = checkValue(newValue, this.props);
      this.setState({
        displayValue: newValue,
        message,
        bound
      });

      // if the input is or can be valid
      if (value !== undefined) {
        // if there is additional processing, call it
        onValueChange && onValueChange(value, newValue);
      }
    });
    (0, _defineProperty2.default)(this, "_onValueAccept", newValue => {
      const {
        value,
        onValueAccept
      } = this.props;
      const oldValue = fixupValue(value, this._useOnValueCallbacks);
      const {
        value: newBoundValue
      } = checkValue(newValue, this.props);
      const {
        value: oldBoundValue,
        message,
        bound
      } = checkValue(oldValue, this.props);
      this.setState({
        displayValue: oldValue,
        message,
        bound
      });

      // check if the old input does not match the new input
      //    if both old and new are valid non-empty values compare for match as numbers
      //       else compare for match as strings
      // this may result in a callback where the boundValue has not changed even though the value has
      if (oldBoundValue && oldValue.length && newBoundValue && newValue.length ? Number(oldValue) !== Number(newValue) : oldValue !== newValue) {
        // if there is additional processing
        onValueAccept && onValueAccept(newBoundValue, newValue);
      }
    });
    (0, _defineProperty2.default)(this, "_inputToRender", props => {
      const {
        min,
        max,
        ltMax,
        gtMin,
        step
      } = this.props;
      const {
        bound
      } = this.state;

      // this is not quite right but the best Carbon has to address ltMax and gtMin
      const mappedMin = !bound && min !== undefined ? min + (gtMin ? step : 0) : undefined;
      const mappedMax = !bound && max !== undefined ? max - (ltMax ? step : 0) : undefined;
      return /*#__PURE__*/_react.default.createElement(_baUiCarbon.NumberInput, (0, _extends2.default)({}, props, {
        min: mappedMin,
        max: mappedMax,
        step: step
      }));
    });
    this.state = {
      displayValue: undefined,
      message: undefined,
      bound: false
    };
  }
  static getDerivedStateFromProps(props, state) {
    const {
      value,
      onValueChange,
      onValueAccept
    } = props;
    if (state.value !== value) {
      const fixedValue = fixupValue(value, !!onValueChange || !!onValueAccept);
      const {
        message,
        bound
      } = checkValue(fixedValue, props);
      return {
        displayValue: fixedValue,
        message,
        bound,
        value
      };
    }
    return null;
  }

  // eventually/hopefully onValueChange/onValueAccept will be the norm, and useOnValueCallbacks can be removed

  focus() {
    const {
      disabled
    } = this.props;
    !disabled && this._input && this._input.focus();
  }
  _constrainedValue(value) {
    const {
      min,
      max,
      scale,
      gtMin,
      ltMax
    } = this.props;
    if (!value || isNaN(value)) {
      return '';
    }
    const scaleValue = 10 ** scale; // ES6 syntax for Math.pow(10, scale);
    let number = Math.floor(Number(value) * scaleValue) / scaleValue;
    if (min != null) {
      const scaledMin = Math.floor(min * scaleValue) / scaleValue;
      number = Math.max(scaledMin, number);
      if (gtMin && number === scaledMin) {
        return String(number + 10 ** -scale);
      }
    }
    if (max != null) {
      const scaledMax = Math.floor(max * scaleValue) / scaleValue;
      number = Math.min(scaledMax, number);
      if (ltMax && number === scaledMax) {
        return String(number - 10 ** -scale);
      }
    }
    return String(number);
  }
  render() {
    // extract props that are to be manipulated or not passed down
    const {
      // props we dont want to send to Carbon
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      min,
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      max,
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      ltMax,
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      gtMin,
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      step,
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      scale,
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      validation,
      // inherited props
      className,
      onChange,
      onBlur,
      validationErrorText,
      hasValidationError,
      // all the other props
      ...others
    } = this.props;
    const {
      displayValue,
      message
    } = this.state;
    const classNames = (0, _utils.classnames)(`${STYLE_CLASS}`);
    const mappedMessage = this._useOnValueCallbacks && message ? message : undefined;
    return (
      /*#__PURE__*/
      // ideally baseInput is only a temporary wrapper to handle error handling
      // as such the only props that should need to be sent to it are those dealing with message handling
      _react.default.createElement(_baseinput.default, (0, _extends2.default)({
        inputToRender: this._inputToRender,
        id: "number-input",
        "data-tid": STYLE_CLASS
      }, sanitize(others, NumberInput), getInheritedProps(others, _baseinput.default), {
        className: `${classNames} ${className}`,
        ref: this._ref,
        value: displayValue,
        onBlur: this._useOnValueCallbacks ? onBlur : this._onBlur,
        onChange: this._useOnValueCallbacks ? onChange : this._onChange,
        onValueChange: this._useOnValueCallbacks ? this._onValueChange : undefined,
        onValueAccept: this._useOnValueCallbacks ? this._onValueAccept : undefined,
        validationErrorText: mappedMessage || validationErrorText,
        hasValidationError: mappedMessage ? true : hasValidationError,
        type: "number"
      }))
    );
  }
}
exports["default"] = NumberInput;
(0, _defineProperty2.default)(NumberInput, "propTypes", {
  ..._baseinput.default.propTypes,
  // these props have a different definition then the baseInput props
  type: _propTypes.default.oneOf([]),
  // these props are in addition to the baseInput props
  max: _propTypes.default.number,
  ltMax: _propTypes.default.bool,
  gtMin: _propTypes.default.bool,
  min: _propTypes.default.number,
  step: _propTypes.default.number,
  scale: _propTypes.default.number,
  validation: _propTypes.default.func
});
(0, _defineProperty2.default)(NumberInput, "defaultProps", {
  scale: 10,
  className: '',
  style: {},
  step: 1,
  allowEmpty: false
});

/***/ }),

/***/ 48165:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


var _interopRequireDefault = __webpack_require__(97880);
exports.__esModule = true;
var _NumberInput = _interopRequireDefault(__webpack_require__(27611));
exports["default"] = _NumberInput.default;
exports.NumberInput = _NumberInput.default;

/***/ }),

/***/ 92460:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


var _interopRequireDefault = __webpack_require__(97880);
exports.__esModule = true;
exports["default"] = void 0;
var _utils = __webpack_require__(78815);
var _NumberInputResources = _interopRequireDefault(__webpack_require__(27213));
/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */
// eslint-disable-line
var _default = exports["default"] = new _utils.StringResource(_NumberInputResources.default);

/***/ }),

/***/ 20849:
/***/ ((module, exports, __webpack_require__) => {

exports = module.exports = __webpack_require__(98060)(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports
exports.locals = {
	"numberInputClassName": "\"ba-common-numberInput\""
};

/***/ }),

/***/ 58610:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93379);
/* harmony import */ var _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7795);
/* harmony import */ var _node_modules_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(90569);
/* harmony import */ var _node_modules_style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3565);
/* harmony import */ var _node_modules_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(19216);
/* harmony import */ var _node_modules_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(44589);
/* harmony import */ var _node_modules_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_NumberInput_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(20849);
/* harmony import */ var _node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_NumberInput_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_NumberInput_scss__WEBPACK_IMPORTED_MODULE_6__);
/* harmony reexport (unknown) */ var __WEBPACK_REEXPORT_OBJECT__ = {};
/* harmony reexport (unknown) */ for(const __WEBPACK_IMPORT_KEY__ in _node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_NumberInput_scss__WEBPACK_IMPORTED_MODULE_6__) if(__WEBPACK_IMPORT_KEY__ !== "default") __WEBPACK_REEXPORT_OBJECT__[__WEBPACK_IMPORT_KEY__] = () => _node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_NumberInput_scss__WEBPACK_IMPORTED_MODULE_6__[__WEBPACK_IMPORT_KEY__]
/* harmony reexport (unknown) */ __webpack_require__.d(__webpack_exports__, __WEBPACK_REEXPORT_OBJECT__);

      
      
      
      
      
      
      
      
      

var options = {};

options.styleTagTransform = (_node_modules_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5___default());
options.setAttributes = (_node_modules_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3___default());

      options.insert = _node_modules_style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2___default().bind(null, "head");
    
options.domAPI = (_node_modules_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1___default());
options.insertStyleElement = (_node_modules_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4___default());

var update = _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0___default()((_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_NumberInput_scss__WEBPACK_IMPORTED_MODULE_6___default()), options);




       /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_NumberInput_scss__WEBPACK_IMPORTED_MODULE_6___default()) && (_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_NumberInput_scss__WEBPACK_IMPORTED_MODULE_6___default().locals) ? (_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_NumberInput_scss__WEBPACK_IMPORTED_MODULE_6___default().locals) : undefined);


/***/ }),

/***/ 93379:
/***/ ((module) => {

"use strict";


var stylesInDOM = [];
function getIndexByIdentifier(identifier) {
  var result = -1;
  for (var i = 0; i < stylesInDOM.length; i++) {
    if (stylesInDOM[i].identifier === identifier) {
      result = i;
      break;
    }
  }
  return result;
}
function modulesToDom(list, options) {
  var idCountMap = {};
  var identifiers = [];
  for (var i = 0; i < list.length; i++) {
    var item = list[i];
    var id = options.base ? item[0] + options.base : item[0];
    var count = idCountMap[id] || 0;
    var identifier = "".concat(id, " ").concat(count);
    idCountMap[id] = count + 1;
    var indexByIdentifier = getIndexByIdentifier(identifier);
    var obj = {
      css: item[1],
      media: item[2],
      sourceMap: item[3],
      supports: item[4],
      layer: item[5]
    };
    if (indexByIdentifier !== -1) {
      stylesInDOM[indexByIdentifier].references++;
      stylesInDOM[indexByIdentifier].updater(obj);
    } else {
      var updater = addElementStyle(obj, options);
      options.byIndex = i;
      stylesInDOM.splice(i, 0, {
        identifier: identifier,
        updater: updater,
        references: 1
      });
    }
    identifiers.push(identifier);
  }
  return identifiers;
}
function addElementStyle(obj, options) {
  var api = options.domAPI(options);
  api.update(obj);
  var updater = function updater(newObj) {
    if (newObj) {
      if (newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap && newObj.supports === obj.supports && newObj.layer === obj.layer) {
        return;
      }
      api.update(obj = newObj);
    } else {
      api.remove();
    }
  };
  return updater;
}
module.exports = function (list, options) {
  options = options || {};
  list = list || [];
  var lastIdentifiers = modulesToDom(list, options);
  return function update(newList) {
    newList = newList || [];
    for (var i = 0; i < lastIdentifiers.length; i++) {
      var identifier = lastIdentifiers[i];
      var index = getIndexByIdentifier(identifier);
      stylesInDOM[index].references--;
    }
    var newLastIdentifiers = modulesToDom(newList, options);
    for (var _i = 0; _i < lastIdentifiers.length; _i++) {
      var _identifier = lastIdentifiers[_i];
      var _index = getIndexByIdentifier(_identifier);
      if (stylesInDOM[_index].references === 0) {
        stylesInDOM[_index].updater();
        stylesInDOM.splice(_index, 1);
      }
    }
    lastIdentifiers = newLastIdentifiers;
  };
};

/***/ }),

/***/ 90569:
/***/ ((module) => {

"use strict";


var memo = {};

/* istanbul ignore next  */
function getTarget(target) {
  if (typeof memo[target] === "undefined") {
    var styleTarget = document.querySelector(target);

    // Special case to return head of iframe instead of iframe itself
    if (window.HTMLIFrameElement && styleTarget instanceof window.HTMLIFrameElement) {
      try {
        // This will throw an exception if access to iframe is blocked
        // due to cross-origin restrictions
        styleTarget = styleTarget.contentDocument.head;
      } catch (e) {
        // istanbul ignore next
        styleTarget = null;
      }
    }
    memo[target] = styleTarget;
  }
  return memo[target];
}

/* istanbul ignore next  */
function insertBySelector(insert, style) {
  var target = getTarget(insert);
  if (!target) {
    throw new Error("Couldn't find a style target. This probably means that the value for the 'insert' parameter is invalid.");
  }
  target.appendChild(style);
}
module.exports = insertBySelector;

/***/ }),

/***/ 19216:
/***/ ((module) => {

"use strict";


/* istanbul ignore next  */
function insertStyleElement(options) {
  var element = document.createElement("style");
  options.setAttributes(element, options.attributes);
  options.insert(element, options.options);
  return element;
}
module.exports = insertStyleElement;

/***/ }),

/***/ 3565:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


/* istanbul ignore next  */
function setAttributesWithoutAttributes(styleElement) {
  var nonce =  true ? __webpack_require__.nc : 0;
  if (nonce) {
    styleElement.setAttribute("nonce", nonce);
  }
}
module.exports = setAttributesWithoutAttributes;

/***/ }),

/***/ 7795:
/***/ ((module) => {

"use strict";


/* istanbul ignore next  */
function apply(styleElement, options, obj) {
  var css = "";
  if (obj.supports) {
    css += "@supports (".concat(obj.supports, ") {");
  }
  if (obj.media) {
    css += "@media ".concat(obj.media, " {");
  }
  var needLayer = typeof obj.layer !== "undefined";
  if (needLayer) {
    css += "@layer".concat(obj.layer.length > 0 ? " ".concat(obj.layer) : "", " {");
  }
  css += obj.css;
  if (needLayer) {
    css += "}";
  }
  if (obj.media) {
    css += "}";
  }
  if (obj.supports) {
    css += "}";
  }
  var sourceMap = obj.sourceMap;
  if (sourceMap && typeof btoa !== "undefined") {
    css += "\n/*# sourceMappingURL=data:application/json;base64,".concat(btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))), " */");
  }

  // For old IE
  /* istanbul ignore if  */
  options.styleTagTransform(css, styleElement, options.options);
}
function removeStyleElement(styleElement) {
  // istanbul ignore if
  if (styleElement.parentNode === null) {
    return false;
  }
  styleElement.parentNode.removeChild(styleElement);
}

/* istanbul ignore next  */
function domAPI(options) {
  if (typeof document === "undefined") {
    return {
      update: function update() {},
      remove: function remove() {}
    };
  }
  var styleElement = options.insertStyleElement(options);
  return {
    update: function update(obj) {
      apply(styleElement, options, obj);
    },
    remove: function remove() {
      removeStyleElement(styleElement);
    }
  };
}
module.exports = domAPI;

/***/ }),

/***/ 44589:
/***/ ((module) => {

"use strict";


/* istanbul ignore next  */
function styleTagTransform(css, styleElement) {
  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = css;
  } else {
    while (styleElement.firstChild) {
      styleElement.removeChild(styleElement.firstChild);
    }
    styleElement.appendChild(document.createTextNode(css));
  }
}
module.exports = styleTagTransform;

/***/ }),

/***/ 6536:
/***/ ((module) => {

"use strict";
module.exports = require("@ba/ba-ui-carbon");

/***/ }),

/***/ 68779:
/***/ ((module) => {

"use strict";
module.exports = require("@babel/runtime/helpers/defineProperty");

/***/ }),

/***/ 38213:
/***/ ((module) => {

"use strict";
module.exports = require("@babel/runtime/helpers/extends");

/***/ }),

/***/ 97880:
/***/ ((module) => {

"use strict";
module.exports = require("@babel/runtime/helpers/interopRequireDefault");

/***/ }),

/***/ 98060:
/***/ ((module) => {

"use strict";
module.exports = require("css-loader/lib/css-base");

/***/ }),

/***/ 580:
/***/ ((module) => {

"use strict";
module.exports = require("prop-types");

/***/ }),

/***/ 16689:
/***/ ((module) => {

"use strict";
module.exports = require("react");

/***/ }),

/***/ 83828:
/***/ ((module) => {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__83828__;

/***/ }),

/***/ 78815:
/***/ ((module) => {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__78815__;

/***/ })

},
/******/ __webpack_require__ => { // webpackRuntimeModules
/******/ var __webpack_exec__ = (moduleId) => (__webpack_require__(__webpack_require__.s = moduleId))
/******/ var __webpack_exports__ = (__webpack_exec__(48165));
/******/ return __webpack_exports__;
/******/ }
]);
});